import React, { useEffect } from 'react';

/**
 * Meta Pixel base code — Ice Machine Diagnostic Pro (DPS66).
 * Heredado de la plantilla: confirmar si este producto usa el mismo pixel.
 * Único pixel de la página: se inicializa una sola vez y dispara PageView.
 */
const PIXEL_ID = '2004445210124846';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!PIXEL_ID) return;
    if ((window as any).__metaPixelInjected) return;
    if ((window as any).fbq) return;
    (window as any).__metaPixelInjected = true;
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return null;
}